import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as OrganizationPersonActions from 'web-app/react/entities/organization-persons/actions';

import * as Actions from './actions';

const OrganizationPersonModal = Record({
    organizationId: String(),
    initialPerson: null,
    isVisible: false,
    submitting: false,
});

export default handleActions(
    {
        [Actions.showOrganizationPersonModal.type]: (state, {payload}) => {
            return state.merge({
                isVisible: true,
                organizationId: payload.organizationId,
            });
        },

        [Actions.showEditPerson.type]: (state, {payload}) => {
            return state.merge({
                isVisible: true,
                organizationId: payload.person.organizationId,
                initialPerson: payload.person,
            });
        },

        [Actions.hideOrganizationPersonModal.type]: () => {
            return new OrganizationPersonModal();
        },

        [OrganizationPersonActions.create.type]: state => {
            return state.merge({
                submitting: true,
            });
        },
        [OrganizationPersonActions.createSuccess.type]: () => {
            return new OrganizationPersonModal();
        },
        [OrganizationPersonActions.createFailed.type]: state => {
            return state.merge({
                submitting: false,
            });
        },

        [OrganizationPersonActions.update.type]: state => {
            return state.merge({
                submitting: true,
            });
        },
        [OrganizationPersonActions.updateSuccess.type]: () => {
            return new OrganizationPersonModal();
        },
        [OrganizationPersonActions.updateFailed.type]: state => {
            return state.merge({
                submitting: false,
            });
        },
    },
    new OrganizationPersonModal(),
);
